import React, { memo } from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div data-id="element-3">
          <div className="text-center mb-10" data-id="element-4">
            <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-5">
              🎁 6 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-[#00C853] font-bold text-lg" data-id="element-6">
              SIEMPRE INCLUIDOS
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
            {/* Bono 1 */}
            <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-8">
              <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-9">01</div>
              <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
                🎁 BONO 1
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
                Plan Anti-Caos
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">
                Calendario anual A1→C2 listo en 30 minutos.
              </p>
              <div className="flex items-center gap-2" data-id="element-13">
                <span className="text-gray-400 line-through text-sm" data-id="element-14">
                  $8.000
                </span>
                <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-16">
              <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-17">02</div>
              <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-18">
                🎁 BONO 2
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-19">
                Banco de Roleplays
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-20">
                20 situaciones reales para hablar italiano desde el día 1.
              </p>
              <div className="flex items-center gap-2" data-id="element-21">
                <span className="text-gray-400 line-through text-sm" data-id="element-22">
                  $10.000
                </span>
                <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-23">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-24">
              <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-25">03</div>
              <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-26">
                🎁 BONO 3
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-27">
                Kit Niveles Mixtos
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-28">
                Clase funcional aunque tengas distintos niveles juntos.
              </p>
              <div className="flex items-center gap-2" data-id="element-29">
                <span className="text-gray-400 line-through text-sm" data-id="element-30">
                  $9.000
                </span>
                <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-31">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 4 */}
            <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-32">
              <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-33">04</div>
              <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-34">
                🎁 BONO 4
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-35">
                Scripts Profe Seguro
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-36">
                100+ frases para dirigir tu clase 100% en italiano.
              </p>
              <div className="flex items-center gap-2" data-id="element-37">
                <span className="text-gray-400 line-through text-sm" data-id="element-38">
                  $8.000
                </span>
                <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-39">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 5 */}
            <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-40">
              <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-41">05</div>
              <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-42">
                🎁 BONO 5
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-43">
                Pack Errores Típicos
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-44">
                Framework de 20 segundos para corregir sin frustrar.
              </p>
              <div className="flex items-center gap-2" data-id="element-45">
                <span className="text-gray-400 line-through text-sm" data-id="element-46">
                  $9.000
                </span>
                <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-47">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Bono 6 */}
            <div className="bg-[#001a0d] border border-[#00C853] rounded-2xl p-6 flex flex-col" data-id="element-48">
              <div className="text-4xl font-black text-[#00C853] mb-1" data-id="element-49">06</div>
              <div className="text-[#00C853] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-50">
                🎁 BONO 6
              </div>
              <h3 className="text-white font-black text-lg mb-2" data-id="element-51">
                Sistema Clase Brillante
              </h3>
              <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-52">
                El Sistema 3C para que cada clase se sienta profesional.
              </p>
              <div className="flex items-center gap-2" data-id="element-53">
                <span className="text-gray-400 line-through text-sm" data-id="element-54">
                  $9.000
                </span>
                <span className="bg-[#00C853] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-55">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="border border-[#00C853]/40 rounded-2xl p-6 text-center bg-[#000d08]" data-id="element-56">
            <p className="text-[#00C853] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-57">
              Valor total bonos
            </p>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-58">
              <span className="text-gray-400 line-through text-lg" data-id="element-59">
                $53.000
              </span>
              <span className="text-[#00C853] text-2xl font-black tracking-wide" data-id="element-60">
                → GRATIS con tu MegaPack
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}